import { IconButtonTestIdFactory } from '../../../../buttons/interactions';
export const PagerTestIdFactory = {
    // bases
    getPagerBase: () => 'pager',
    // for test id generation
    getPagerFirstTestId: (tableId) => IconButtonTestIdFactory.getIconButtonTestId(PagerTestIdFactory.internalGeneratePagerTestId('first', tableId)),
    getPagerPreviousTestId: (tableId) => IconButtonTestIdFactory.getIconButtonTestId(PagerTestIdFactory.internalGeneratePagerTestId('previous', tableId)),
    getPagerNextTestId: (tableId) => IconButtonTestIdFactory.getIconButtonTestId(PagerTestIdFactory.internalGeneratePagerTestId('next', tableId)),
    getPagerLastTestId: (tableId) => IconButtonTestIdFactory.getIconButtonTestId(PagerTestIdFactory.internalGeneratePagerTestId('last', tableId)),
    getPagerPageTestId: (pageNumber, tableId) => PagerTestIdFactory.internalGeneratePagerTestId(String(pageNumber), tableId),
    // internal don't use outside of component
    internalGeneratePagerTestId: (suffix, tableId) => [PagerTestIdFactory.getPagerBase(), suffix, tableId].join('-'),
};
